import ScrollSync from './ScrollSync';

export default ScrollSync;
export { ScrollSync };